function StLucia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2209)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#338AF3"/>
  <path d="M10.0869 21.5653H21.913L16 7.65234L10.0869 21.5653Z" fill="#F3F3F3"/>
  <path d="M12.142 20.174L16 11.3984L19.8581 20.174H12.142Z" fill="#333333"/>
  <path d="M10.0869 21.5652H21.913L16 16L10.0869 21.5652Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default StLucia;
